import { render, staticRenderFns } from "./smart-item.vue?vue&type=template&id=3b2fb4ee&scoped=true"
import script from "./smart-item.vue?vue&type=script&lang=js"
export * from "./smart-item.vue?vue&type=script&lang=js"
import style0 from "./smart-item.vue?vue&type=style&index=0&id=3b2fb4ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2fb4ee",
  null
  
)

export default component.exports